export const isWin = navigator.platform === 'Win32' || navigator.platform === 'Windows';
export const isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel';
export const isLinux = String(navigator.platform).includes('Linux');

export const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isOnline = process.env.REACT_APP_ENVIRONMENT === 'online';
export const isGray = process.env.REACT_APP_ENVIRONMENT === 'gray';
export const kuEnv = process.env.REACT_APP_ENVIRONMENT;

const WIKI_JSQ_VERSIONS_ONLINE = {
    Beta: 'WIKI_JSQ_BETA',
    Canary01: 'WIKI_JSQ_CANARY01',
    Canary02: 'WIKI_JSQ_CANARY02',
};

const WIKI_JSQ_VERSIONS_GRAY = {
    Beta: 'WIKI_JSQ_BETA_GRAY',
    Canary01: 'WIKI_JSQ_CANARY01_GRAY',
    Canary02: 'WIKI_JSQ_CANARY02_GRAY',
};

export const WIKI_JSQ_VERSIONS =
    process.env.REACT_APP_ENVIRONMENT === 'online' ? WIKI_JSQ_VERSIONS_ONLINE : WIKI_JSQ_VERSIONS_GRAY;
